import Record from './Record';
import RecordFooter from './RecordFooter';

export { Record, RecordFooter };
